import { patientNamespace } from "@/store/modules/patient";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class SelectSortBy extends Vue {
  @Getter("vars", patientNamespace)
  vars!: any;

  @Getter("selectedSort", patientNamespace)
  selectedSort!: string;

  @Getter("towerMode", patientNamespace)
  towerMode!: boolean;

  updateSort(sort: string) {
    this.$router.replace({ params: { sort } });
  }

  @Prop(Array)
  sortByItems!: { text: string; value: string }[];
}
